export default __webpack_public_path__ + "static/media/60_desktop.09740c35.jpg";